import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { SkeletonLoader } from '@frontend/design-system';

export const SkeletonListLoader = () => {
  return (
    <>
      {Array.from({ length: 10 }).map((_, idx) => (
        <section
          key={idx}
          css={css`
            display: flex;
            gap: ${theme.spacing(2)};
            align-items: center;
            padding: ${theme.spacing(2)};
            width: 100%;
            border-bottom: 1px solid ${theme.colors.neutral10};
          `}
        >
          <SkeletonLoader shape='circle' width={50} height={50} />
          <div>
            <SkeletonLoader
              width={150}
              height={20}
              css={css`
                margin-bottom: ${theme.spacing(1)};
              `}
            />
            <SkeletonLoader
              width={100}
              height={16}
              css={css`
                margin-bottom: ${theme.spacing(1)};
              `}
            />
            <SkeletonLoader
              width={100}
              height={16}
              css={css`
                margin-bottom: ${theme.spacing(1)};
              `}
            />
          </div>
        </section>
      ))}
    </>
  );
};
